import { useAtom } from 'jotai';
import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { Redirect } from 'react-router-dom';

import Stack from '@mui/material/Stack';
import Box from '@mui/system/Box';

import {
  authTokenAtom,
  locationsAtom,
  selectedLocationIdAtom,
} from '../utils/AtomConfig';
import Constants from '../utils/Constants';
import { MdiService } from '../utils/MdiService';
import { QuickFilter } from './QuickFilter';
import { SearchBox } from './SearchBox';
import { SearchResult } from './SearchResult';
import { LoadingSpinner } from './LoadingSpinner';
import { Refiners } from './Refiners';

export const Home = () => {
  const [authToken] = useAtom(authTokenAtom);
  const [, setLocations] = useAtom(locationsAtom);
  const [, setSelectedLocationId] = useAtom(selectedLocationIdAtom);
  const [hasNoAccess, setHasNoAccess] = useState(false);

  const mdiService = MdiService.Instance;

  // Get locations when auth token is available
  const locationsQuery = useQuery(
    Constants.QUERY_KEYS.LOCATIONS,
    () => mdiService.GetLocations(),
    {
      ...Constants.BASE_DISABLE_REFETCH_SETTINGS,
      enabled: !!authToken,
      onSuccess: (result) => {
        if (result.length === 0) {
          setHasNoAccess(true);
          return;
        }

        setLocations(result);
        setSelectedLocationId(result[0].id);
      },
    }
  );

  // Show loading spinner on initial load
  if (locationsQuery.isLoading) {
    return (
      <Stack sx={{ marginTop: 6 }}>
        <LoadingSpinner></LoadingSpinner>;
      </Stack>
    );
  }

  if (hasNoAccess) {
    return (
      <Redirect
        to={{
          pathname: '/error',
          state: {
            severity: 'warning',
            message: `Your account doesn't have access to any locations. Please try again and contact administrator if the problem still persists.`,
          },
        }}
      />
    );
  }

  return (
    <Stack>
      <QuickFilter />
      <Stack
        direction='column'
        sx={{
          position: 'fixed',
          top: 64,
          bottom: 0,
          padding: 2,
          backgroundColor: '#ECECF7',
          width: 367,
          color: '#003591',
          left: 240,
          overflowY: 'auto',
          overflowX: 'hidden',
          display: {
            xs: 'none',
            md: 'flex',
          },
        }}
      >
        <Refiners />
      </Stack>
      <Box
        sx={{
          flexGrow: 1,
          marginLeft: {
            sm: '0',
            md: '607px',
          },
          marginTop: '64px',
          padding: 2,
        }}
      >
        <SearchBox />
        <SearchResult />
      </Box>
    </Stack>
  );
};
